export default {
  product: {
    name: 'Kup kartę podarunkową',
  },
  description: {
    items: {
      delivery: 'Wysyłana natychmiast e-mailem jako PDF',
      usage: {
        online: 'Do realizacji tylko online',
        online_and_store: 'Do realizacji online i w restauracji',
      },
      value: 'Elastyczne kwoty od {{from}} do {{to}}',
    },
  },
};
